
    // import React, { useEffect, useState } from "react";
    // import axios from "../api/axiosAuth";

    // import io from "socket.io-client";
    // import { useAuth } from "../context/AuthContext";
    // import jsPDF from "jspdf";
    // import "jspdf-autotable";
    // import "../style/tareas.css";

    // /* ===============================
    //    🌐 CONSTANTES
    // ================================ */
    // const API_BASE = "http://localhost:5001/api";
    // const API_TAREAS = `${API_BASE}/tasks`;
    // const SOCKET_URL = "http://localhost:5001";

    // /* ===============================
    //    🧠 COMPONENTE
    // ================================ */
    // function TareasProfesor() {
    //   const { user, token, isProfesor } = useAuth();

    //   const [tareas, setTareas] = useState([]);
    //   const [asignaciones, setAsignaciones] = useState([]);
    //   const [grados, setGrados] = useState([]);
    //   const [grupos, setGrupos] = useState([]);

    //   const [selectedGrado, setSelectedGrado] = useState("");
    //   const [selectedGrupo, setSelectedGrupo] = useState("");
    //   const [selectedAsignacion, setSelectedAsignacion] = useState(null);

    //   const [title, setTitle] = useState("");
    //   const [description, setDescription] = useState("");
    //   const [dueDate, setDueDate] = useState("");
    //   const [archivo, setArchivo] = useState(null);

    //   const [responses, setResponses] = useState([]);
    //   const [stats, setStats] = useState([]);
    //   const [selectedTaskId, setSelectedTaskId] = useState(null);

    //   const [vista, setVista] = useState("historial");
    //   const [periodos, setPeriodos] = useState([]);
    //   const [periodoActivo, setPeriodoActivo] = useState(null);
    //   const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);

    //   /* ===============================
    //      🚀 INIT
    //   =============================== */
    //   useEffect(() => {
    //     if (!user || !token || !isProfesor()) return;

    //     fetchPeriodos();
    //     fetchPeriodoActivo();
    //     fetchAsignaciones();

    //     const socket = io(SOCKET_URL, { auth: { token } });

    //     socket.on(`teacher:${user.id}`, () => {
    //       if (periodoSeleccionado) {
    //         fetchHistorial(periodoSeleccionado);
    //       }
    //     });

    //     return () => socket.disconnect();
    //   }, [user, token]);

    //   /* ===============================
    //      📆 PERIODOS
    //   =============================== */
    //   const fetchPeriodos = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/periodos`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });
    //       setPeriodos(res.data || []);
    //     } catch (err) {
    //       console.error("❌ Error cargando periodos", err);
    //       setPeriodos([]);
    //     }
    //   };

    //   const fetchPeriodoActivo = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/periodos/activo`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });

    //       if (res.data) {
    //         setPeriodoActivo(res.data);
    //         setPeriodoSeleccionado(res.data.id);
    //         fetchHistorial(res.data.id);
    //       }
    //     } catch (err) {
    //       console.error("❌ Error obteniendo periodo activo", err);
    //     }
    //   };

    //   const handlePeriodoChange = (periodoId) => {
    //     setPeriodoSeleccionado(periodoId || null);
    //     fetchHistorial(periodoId || null);
    //   };

    //   /* ===============================
    //      📚 ASIGNACIONES
    //   =============================== */
    //   const fetchAsignaciones = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/profesor/asignaciones`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });

    //       const data = res.data || [];
    //       setAsignaciones(data);

    //       const gradosUnicos = [...new Set(data.map((a) => String(a.grado)))];
    //       setGrados(gradosUnicos);
    //     } catch (err) {
    //       console.error("❌ Error cargando asignaciones", err);
    //     }
    //   };

    //   const handleGradoChange = (grado) => {
    //     setSelectedGrado(grado);
    //     setSelectedGrupo("");
    //     setSelectedAsignacion(null);

    //     const gruposUnicos = [
    //       ...new Set(
    //         asignaciones
    //           .filter((a) => String(a.grado) === String(grado))
    //           .map((a) => String(a.grupo))
    //       )
    //     ];

    //     setGrupos(gruposUnicos);
    //   };

    //   const handleGrupoChange = (grupo) => {
    //     setSelectedGrupo(grupo);

    //     const asignacion = asignaciones.find(
    //       (a) =>
    //         String(a.grado) === String(selectedGrado) &&
    //         String(a.grupo) === String(grupo)
    //     );

    //     if (!asignacion?.asignacion_id) {
    //       alert("⚠️ No se encontró asignación válida");
    //       return;
    //     }

    //     setSelectedAsignacion(Number(asignacion.asignacion_id));
    //   };

    //   /* ===============================
    //      📝 TAREAS
    //   =============================== */
    //   const fetchHistorial = async (periodoId) => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/profesor/historial`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //         params: { periodo_id: periodoId }
    //       });

    //       setTareas(res.data || []);
    //       setVista("historial");
    //     } catch (err) {
    //       console.error("❌ Error cargando historial", err);
    //       setTareas([]);
    //     }
    //   };

    //   const handleCreateTask = async (e) => {
    //     e.preventDefault();

    //     if (!title.trim() || !dueDate || !selectedAsignacion) {
    //       return alert("⚠️ Completa todos los campos");
    //     }

    //     const formData = new FormData();
    //     formData.append("asignacion_id", selectedAsignacion);
    //     formData.append("title", title.trim());
    //     formData.append("description", description || "");
    //     formData.append("due_date", dueDate);
    //     if (archivo) formData.append("archivo", archivo);

    //     try {
    //       await axios.post(API_TAREAS, formData, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });

    //       alert("✅ Tarea creada correctamente");
    //       fetchHistorial(periodoSeleccionado);

    //       setTitle("");
    //       setDescription("");
    //       setDueDate("");
    //       setArchivo(null);
    //       setSelectedGrado("");
    //       setSelectedGrupo("");
    //       setSelectedAsignacion(null);
    //     } catch (err) {
    //       console.error("❌ Error creando tarea", err);
    //       alert("❌ Error al crear tarea");
    //     }
    //   };

    //   /* ===============================
    //      📥 RESPUESTAS
    //   =============================== */
    //   const handleViewResponses = async (taskId) => {
    //     try {
    //   const res = await axios.get(`${API_TAREAS}/${taskId}/responses`, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     "Cache-Control": "no-cache"
    //   }
    // });


    //       setResponses(res.data || []);
    //       setSelectedTaskId(taskId);
    //       setVista("respuestas");
    //     } catch (err) {
    //       console.error("❌ Error cargando respuestas", err);
    //       setResponses([]);
    //     }
    //   };

    //   const fetchNoRespondidas = async (taskId) => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/${taskId}/no-respondidas`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });

    //       setStats(res.data || []);
    //       setSelectedTaskId(taskId);
    //       setVista("no-respondidas");
    //     } catch (err) {
    //       console.error("❌ Error no respondidas", err);
    //       setStats([]);
    //     }
    //   };

    //   const handleGrade = async (responseId) => {
    //     const calificacion = prompt("Ingrese calificación (1 a 5)");
    //     if (!calificacion) return;

    //     try {
    //       await axios.post(
    //         `${API_TAREAS}/responses/${responseId}/grade`,
    //         { calificacion: Number(calificacion) },
    //         { headers: { Authorization: `Bearer ${token}` } }
    //       );

    //       alert("✅ Calificación guardada");
    //       handleViewResponses(selectedTaskId);
    //     } catch (err) {
    //       console.error("❌ Error calificando", err);
    //       alert("❌ Error guardando calificación");
    //     }
    //   };

    //   /* ===============================
    //      📄 EXPORT PDF
    //   =============================== */
    //   const exportPDF = () => {
    //     const doc = new jsPDF();
    //     doc.text("Reporte de tareas del profesor", 14, 15);

    //     doc.autoTable({
    //       startY: 20,
    //       head: [["Título", "Grado", "Grupo", "Estado", "Fecha límite"]],
    //       body: tareas.map((t) => [
    //         t.title,
    //         t.grado || "-",
    //         t.grupo || "-",
    //         t.estado_actual || "-",
    //         t.due_date
    //           ? new Date(t.due_date).toLocaleString()
    //           : "-"
    //       ])
    //     });

    //     doc.save("tareas_profesor.pdf");
    //   };

    //   /* ===============================
    //      🔚 RENDER
    //   =============================== */
    //   if (!user) return <p>Cargando usuario...</p>;
    //   if (!isProfesor()) return <p>Acceso solo para profesores</p>;

    //   return (
    //     <div className="tareas-wrapper">
    //       <h2>📝 Panel del Profesor - Tareas</h2>

    //       {/* 🔸 PERIODO */}
    //       <div style={{ marginBottom: 12 }}>
    //         <strong>Periodo:</strong>{" "}
    //         <select
    //           value={periodoSeleccionado || ""}
    //           onChange={(e) => handlePeriodoChange(e.target.value)}
    //         >
    //           <option value="">Seleccione periodo</option>
    //           {periodos.map((p) => (
    //             <option key={p.id} value={p.id}>
    //               {p.nombre} {p.activo ? "(activo)" : ""}
    //             </option>
    //           ))}
    //         </select>
    //       </div>

    //       {/* 🔸 FORM CREAR */}
    //       <form className="crear-tarea-form" onSubmit={handleCreateTask}>
    //         <h3>Crear nueva tarea</h3>

    //         <input
    //           type="text"
    //           placeholder="Título"
    //           value={title}
    //           onChange={(e) => setTitle(e.target.value)}
    //           required
    //         />

    //         <textarea
    //           placeholder="Descripción"
    //           value={description}
    //           onChange={(e) => setDescription(e.target.value)}
    //         />

    //         <input
    //           type="datetime-local"
    //           value={dueDate}
    //           onChange={(e) => setDueDate(e.target.value)}
    //           required
    //         />

    //         <select
    //           value={selectedGrado}
    //           onChange={(e) => handleGradoChange(e.target.value)}
    //           required
    //         >
    //           <option value="">Seleccione grado</option>
    //           {grados.map((g) => (
    //             <option key={g} value={g}>
    //               Grado {g}
    //             </option>
    //           ))}
    //         </select>

    //         <select
    //           value={selectedGrupo}
    //           onChange={(e) => handleGrupoChange(e.target.value)}
    //           disabled={!selectedGrado}
    //           required
    //         >
    //           <option value="">Seleccione grupo</option>
    //           {grupos.map((g) => (
    //             <option key={g} value={g}>
    //               Grupo {g}
    //             </option>
    //           ))}
    //         </select>

    //         <input type="file" onChange={(e) => setArchivo(e.target.files[0])} />

    //         <button type="submit">Crear tarea</button>
    //       </form>

    //       {/* ===============================
    //          📋 HISTORIAL
    //       =============================== */}
    //       {vista === "historial" && (
    //         <div className="tabla-wrapper">
    //           <div className="tabla-header">
    //             <h3>Historial de tareas</h3>
    //             <button onClick={exportPDF}>Exportar PDF</button>
    //           </div>

    //           {tareas.length === 0 ? (
    //             <p>No hay tareas en este periodo</p>
    //           ) : (
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th>Título</th>
    //                   <th>Grado</th>
    //                   <th>Grupo</th>
    //                   <th>Fecha límite</th>
    //                   <th>Acciones</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {tareas.map((t) => (
    //                   <tr key={t.id}>
    //                     <td>{t.title}</td>
    //                     <td>{t.grado || "-"}</td>
    //                     <td>{t.grupo || "-"}</td>
    //                     <td>
    //                       {t.due_date
    //                         ? new Date(t.due_date).toLocaleString()
    //                         : "-"}
    //                     </td>
    //                     <td>
    //                       <button onClick={() => handleViewResponses(t.id)}>
    //                         Ver respuestas
    //                       </button>
    //                       <button onClick={() => fetchNoRespondidas(t.id)}>
    //                         No respondieron
    //                       </button>
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           )}
    //         </div>
    //       )}

    //       {/* ===============================
    //          📥 RESPUESTAS
    //       =============================== */}
    //    {vista === "respuestas" && (
    //   <div className="tabla-wrapper">
    //     <div className="tabla-header">
    //       <h3>📥 Respuestas de estudiantes</h3>
    //       <button onClick={() => setVista("historial")}>
    //         ← Volver al historial
    //       </button>
    //     </div>

    //     {responses.length === 0 ? (
    //       <p style={{ padding: "10px", fontStyle: "italic" }}>
    //         No hay respuestas aún para esta tarea
    //       </p>
    //     ) : (
    //       <table>
    //         <thead>
    //           <tr>
    //             <th>Estudiante</th>
    //             <th>Grado</th>
    //             <th>Grupo</th>
    //             <th>Respuesta</th>
    //             <th>Archivo</th>
    //             <th>Fecha entrega</th>
    //             <th>Calificación</th>
    //             <th>Acción</th>
    //           </tr>
    //         </thead>

    //         <tbody>
    //           {responses.map((r) => (
    //             <tr key={r.id}>
    //               <td>{r.estudiante_nombre}</td>

    //               <td>{r.grado || "—"}</td>
    //               <td>{r.grupo || "—"}</td>

    //               <td style={{ maxWidth: "300px" }}>
    //                 {r.respuesta?.trim()
    //                   ? r.respuesta
    //                   : <span style={{ opacity: 0.6 }}>Sin respuesta escrita</span>}
    //               </td>

    //               <td>
    //                 {r.archivo ? (
    //                   <a
    //                     href={`${API_BASE}/uploads/${r.archivo}`}
    //                     target="_blank"
    //                     rel="noreferrer"
    //                   >
    //                     📎 Ver archivo
    //                   </a>
    //                 ) : (
    //                   <span style={{ opacity: 0.6 }}>—</span>
    //                 )}
    //               </td>

    //               <td>
    //                 {r.created_at
    //                   ? new Date(r.created_at).toLocaleString()
    //                   : "—"}
    //               </td>

    //               <td>
    //                 {r.calificacion !== null && r.calificacion !== undefined
    //                   ? r.calificacion
    //                   : "—"}
    //               </td>

    //               <td>
    //                 <button
    //                   onClick={() => handleGrade(r.id)}
    //                   style={{
    //                     background: "#4CAF50",
    //                     color: "white",
    //                     border: "none",
    //                     padding: "6px 10px",
    //                     borderRadius: "4px",
    //                     cursor: "pointer"
    //                   }}
    //                 >
    //                   ⭐ Calificar
    //                 </button>
    //               </td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     )}
    //   </div>
    // )}


    //       {/* ===============================
    //          🚫 NO RESPONDIERON
    //       =============================== */}
    //       {vista === "no-respondidas" && (
    //         <div className="tabla-wrapper">
    //           <h3>Estudiantes que no respondieron</h3>
    //           <button onClick={() => setVista("historial")}>
    //             ← Volver
    //           </button>

    //           {stats.length === 0 ? (
    //             <p>Todos los estudiantes respondieron 🎉</p>
    //           ) : (
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th>Estudiante</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {stats.map((e) => (
    //                   <tr key={e.estudiante_id}>
    //                     <td>{e.nombre}</td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           )}
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // export default TareasProfesor;



    // //
    // import React, { useEffect, useState } from "react";
    // import axios from "../api/axiosAuth";
    // import io from "socket.io-client";
    // import { useAuth } from "../context/AuthContext";
    // import jsPDF from "jspdf";
    // import "jspdf-autotable";
    // import "../style/tareas.css";

    // /* ===============================
    //    🌐 CONSTANTES
    // ================================ */
    // const API_BASE = "http://3.236.217.225:5001/api";
    // const API_TAREAS = `${API_BASE}/tasks`;
    // const SOCKET_URL = "http://3.236.217.225:5001";

    // /* ===============================
    //    🧠 COMPONENTE
    // ================================ */
    // function TareasProfesor() {
    //   const { user, token, isProfesor } = useAuth();

    //   const [tareas, setTareas] = useState([]);
    //   const [asignaciones, setAsignaciones] = useState([]);
    //   const [grados, setGrados] = useState([]);
    //   const [grupos, setGrupos] = useState([]);
    //   const [selectedGrado, setSelectedGrado] = useState("");
    //   const [selectedGrupo, setSelectedGrupo] = useState("");
    //   const [selectedAsignacion, setSelectedAsignacion] = useState(null);
    //   const [title, setTitle] = useState("");
    //   const [description, setDescription] = useState("");
    //   const [dueDate, setDueDate] = useState("");
    //   const [archivo, setArchivo] = useState(null);
    //   const [responses, setResponses] = useState([]);
    //   const [stats, setStats] = useState([]);
    //   const [selectedTaskId, setSelectedTaskId] = useState(null);
    //   const [vista, setVista] = useState("historial");
    //   const [periodos, setPeriodos] = useState([]);
    //   const [periodoActivo, setPeriodoActivo] = useState(null);
    //   const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);

    //   /* ===============================
    //      🚀 INIT
    //   =============================== */
    //   useEffect(() => {
    //     if (!user || !token || !isProfesor()) return;

    //     fetchPeriodos();
    //     fetchPeriodoActivo();
    //     fetchAsignaciones();

    //     const socket = io(SOCKET_URL, { auth: { token } });
    //     socket.on(`teacher:${user.id}`, () => {
    //       if (periodoSeleccionado) fetchHistorial(periodoSeleccionado);
    //     });
    //     return () => socket.disconnect();
    //   }, [user, token]);

    //   /* ===============================
    //      📆 PERIODOS
    //   =============================== */
    //   const fetchPeriodos = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/periodos`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });
    //       setPeriodos(res.data || []);
    //     } catch (err) {
    //       console.error("❌ Error cargando periodos", err);
    //       setPeriodos([]);
    //     }
    //   };

    //   const fetchPeriodoActivo = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/periodos/activo`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });
    //       if (res.data) {
    //         setPeriodoActivo(res.data);
    //         setPeriodoSeleccionado(res.data.id);
    //         fetchHistorial(res.data.id);
    //       }
    //     } catch (err) {
    //       console.error("❌ Error obteniendo periodo activo", err);
    //     }
    //   };

    //   const handlePeriodoChange = (periodoId) => {
    //     setPeriodoSeleccionado(periodoId || null);
    //     fetchHistorial(periodoId || null);
    //   };

    //   /* ===============================
    //      📚 ASIGNACIONES
    //   =============================== */
    //   const fetchAsignaciones = async () => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/profesor/asignaciones`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       });
    //       const data = res.data || [];
    //       setAsignaciones(data);
    //       setGrados([...new Set(data.map((a) => String(a.grado)))]);
    //     } catch (err) {
    //       console.error("❌ Error cargando asignaciones", err);
    //     }
    //   };

    //   const handleGradoChange = (grado) => {
    //     setSelectedGrado(grado);
    //     setSelectedGrupo("");
    //     setSelectedAsignacion(null);
    //     const gruposUnicos = [...new Set(asignaciones.filter(a => String(a.grado) === String(grado)).map(a => String(a.grupo)))];
    //     setGrupos(gruposUnicos);
    //   };

    //   const handleGrupoChange = (grupo) => {
    //     setSelectedGrupo(grupo);
    //     const asignacion = asignaciones.find(a => String(a.grado) === String(selectedGrado) && String(a.grupo) === String(grupo));
    //     if (!asignacion?.asignacion_id) return alert("⚠️ No se encontró asignación válida");
    //     setSelectedAsignacion(Number(asignacion.asignacion_id));
    //   };

    //   /* ===============================
    //      📝 TAREAS
    //   =============================== */
    //   const fetchHistorial = async (periodoId) => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/profesor/historial`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //         params: { periodo_id: periodoId }
    //       });
    //       setTareas(res.data || []);
    //       setVista("historial");
    //     } catch (err) {
    //       console.error("❌ Error cargando historial", err);
    //       setTareas([]);
    //     }
    //   };

    //   const handleCreateTask = async (e) => {
    //     e.preventDefault();
    //     if (!title.trim() || !dueDate || !selectedAsignacion) return alert("⚠️ Completa todos los campos");

    //     const formData = new FormData();
    //     formData.append("asignacion_id", selectedAsignacion);
    //     formData.append("title", title.trim());
    //     formData.append("description", description || "");
    //     formData.append("due_date", dueDate);
    //     if (archivo) formData.append("archivo", archivo);

    //     try {
    //       await axios.post(API_TAREAS, formData, { headers: { Authorization: `Bearer ${token}` } });
    //       alert("✅ Tarea creada correctamente");
    //       fetchHistorial(periodoSeleccionado);
    //       setTitle(""); setDescription(""); setDueDate(""); setArchivo(null); setSelectedGrado(""); setSelectedGrupo(""); setSelectedAsignacion(null);
    //     } catch (err) {
    //       console.error("❌ Error creando tarea", err);
    //       alert("❌ Error al crear tarea");
    //     }
    //   };

    //   /* ===============================
    //      📥 RESPUESTAS
    //   =============================== */
    //   const handleViewResponses = async (taskId) => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/${taskId}/responses`, { headers: { Authorization: `Bearer ${token}`, "Cache-Control": "no-cache" } });
    //       setResponses(res.data || []);
    //       setSelectedTaskId(taskId);
    //       setVista("respuestas");
    //     } catch (err) {
    //       console.error("❌ Error cargando respuestas", err);
    //       setResponses([]);
    //     }
    //   };

    //   const fetchNoRespondidas = async (taskId) => {
    //     try {
    //       const res = await axios.get(`${API_TAREAS}/${taskId}/no-respondidas`, { headers: { Authorization: `Bearer ${token}` } });
    //       setStats(res.data || []);
    //       setSelectedTaskId(taskId);
    //       setVista("no-respondidas");
    //     } catch (err) {
    //       console.error("❌ Error no respondidas", err);
    //       setStats([]);
    //     }
    //   };

    //   const handleGrade = async (responseId) => {
    //     const calificacion = prompt("Ingrese calificación (1 a 5)");
    //     if (!calificacion) return;
    //     try {
    //       await axios.post(`${API_TAREAS}/responses/${responseId}/grade`, { calificacion: Number(calificacion) }, { headers: { Authorization: `Bearer ${token}` } });
    //       alert("✅ Calificación guardada");
    //       handleViewResponses(selectedTaskId);
    //     } catch (err) {
    //       console.error("❌ Error calificando", err);
    //       alert("❌ Error guardando calificación");
    //     }
    //   };

    //   const handleBloquear = async (taskId) => { await axios.put(`${API_TAREAS}/${taskId}/bloquear`, {}, { headers: { Authorization: `Bearer ${token}` } }); fetchHistorial(periodoSeleccionado); };
    //   const handleDesbloquear = async (taskId) => { await axios.put(`${API_TAREAS}/${taskId}/desbloquear`, {}, { headers: { Authorization: `Bearer ${token}` } }); fetchHistorial(periodoSeleccionado); };

    //   /* ===============================
    //      ✏️ EDITAR / ELIMINAR
    //   =============================== */
    //   const handleEditar = async (task) => {
    //     const nuevoTitulo = prompt("Editar título", task.title);
    //     if (!nuevoTitulo) return;
    //     try {
    //       await axios.put(`${API_TAREAS}/${task.id}`, { title: nuevoTitulo }, { headers: { Authorization: `Bearer ${token}` } });
    //       fetchHistorial(periodoSeleccionado);
    //     } catch (err) {
    //       console.error("❌ Error editando tarea", err);
    //     }
    //   };

    //   const handleEliminar = async (taskId) => {
    //     if (!window.confirm("⚠️ ¿Seguro que desea eliminar esta tarea?")) return;
    //     try {
    //       await axios.delete(`${API_TAREAS}/${taskId}`, { headers: { Authorization: `Bearer ${token}` } });
    //       fetchHistorial(periodoSeleccionado);
    //     } catch (err) {
    //       console.error("❌ Error eliminando tarea", err);
    //     }
    //   };


      
    //   /* ===============================
    //      📄 EXPORT PDF
    //   =============================== */
    //   const exportPDF = () => {
    //     const doc = new jsPDF();
    //     doc.text("Reporte de tareas del profesor", 14, 15);
    //     doc.autoTable({
    //       startY: 20,
    //       head: [["Título", "Grado", "Grupo", "Estado", "Fecha límite"]],
    //       body: tareas.map(t => [t.title, t.grado || "-", t.grupo || "-", t.estado_actual || "-", t.due_date ? new Date(t.due_date).toLocaleString() : "-"])
    //     });
    //     doc.save("tareas_profesor.pdf");
    //   };

    //   /* ===============================
    //      🔚 RENDER
    //   =============================== */
    //   if (!user) return <p>Cargando usuario...</p>;
    //   if (!isProfesor()) return <p>Acceso solo para profesores</p>;

    //   return (
    //     <div className="tareas-wrapper">
    //       <h2>📝 Panel del Profesor - Tareas</h2>

    //       {/* 🔸 PERIODO */}
    //       <div style={{ marginBottom: 12 }}>
    //         <strong>Periodo:</strong>{" "}
    //         <select value={periodoSeleccionado || ""} onChange={(e) => handlePeriodoChange(e.target.value)}>
    //           <option value="">Seleccione periodo</option>
    //           {periodos.map((p) => (
    //             <option key={p.id} value={p.id}>
    //               {p.nombre} {p.activo ? "(activo)" : ""}
    //             </option>
    //           ))}
    //         </select>
    //       </div>

    //       {/* 🔸 FORM CREAR */}
    //       <form className="crear-tarea-form" onSubmit={handleCreateTask}>
    //         <h3>Crear nueva tarea</h3>
    //         <input type="text" placeholder="Título" value={title} onChange={(e) => setTitle(e.target.value)} required />
    //         <textarea placeholder="Descripción" value={description} onChange={(e) => setDescription(e.target.value)} />
    //         <input type="datetime-local" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required />
    //         <select value={selectedGrado} onChange={(e) => handleGradoChange(e.target.value)} required>
    //           <option value="">Seleccione grado</option>
    //           {grados.map((g) => <option key={g} value={g}>Grado {g}</option>)}
    //         </select>
    //         <select value={selectedGrupo} onChange={(e) => handleGrupoChange(e.target.value)} disabled={!selectedGrado} required>
    //           <option value="">Seleccione grupo</option>
    //           {grupos.map((g) => <option key={g} value={g}>Grupo {g}</option>)}
    //         </select>
    //         <input type="file" onChange={(e) => setArchivo(e.target.files[0])} />
    //         <button type="submit">Crear tarea</button>
    //       </form>

    //       {/* ===============================
    //          📋 HISTORIAL
    //       =============================== */}
    //       {vista === "historial" && (
    //         <div className="tabla-wrapper">
    //           <div className="tabla-header">
    //             <h3>Historial de tareas</h3>
    //             <button onClick={exportPDF}>Exportar PDF</button>
    //           </div>

    //           {tareas.length === 0 ? <p>No hay tareas en este periodo</p> : (
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th>Título</th><th>Grado</th><th>Grupo</th><th>Fecha límite</th><th>Acciones</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {tareas.map((t) => (
    //                   <tr key={t.id}>
    //                     <td>{t.title}</td>
    //                     <td>{t.grado || "-"}</td>
    //                     <td>{t.grupo || "-"}</td>
    //                     <td>{t.due_date ? new Date(t.due_date).toLocaleString() : "-"}</td>
    //                     <td className="acciones-icons">
    //                       <span title="Ver respuestas" onClick={() => handleViewResponses(t.id)} style={{ cursor: "pointer" }}>📥</span>
    //                       <span title="No respondieron" onClick={() => fetchNoRespondidas(t.id)} style={{ cursor: "pointer" }}>⚠️</span>
    //                       <span title="Editar tarea" onClick={() => handleEditar(t)} style={{ cursor: "pointer" }}>✏️</span>
    //                       <span title="Eliminar tarea" onClick={() => handleEliminar(t.id)} style={{ cursor: "pointer" }}>🗑️</span>
    //                       {t.estado_actual === "activa" ? (
    //                         <span title="Bloquear" onClick={() => handleBloquear(t.id)} style={{ cursor: "pointer" }}>🔒</span>
    //                       ) : (
    //                         <span title="Desbloquear" onClick={() => handleDesbloquear(t.id)} style={{ cursor: "pointer" }}>🔓</span>
    //                       )}
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           )}
    //         </div>
    //       )}

    //       {/* ===============================
    //          📥 RESPUESTAS
    //       =============================== */}
    //       {vista === "respuestas" && (
    //         <div className="tabla-wrapper">
    //           <div className="tabla-header">
    //             <h3>📥 Respuestas de estudiantes</h3>
    //             <button onClick={() => setVista("historial")}>← Volver al historial</button>
    //           </div>

    //           {responses.length === 0 ? (
    //             <p style={{ padding: "10px", fontStyle: "italic" }}>No hay respuestas aún para esta tarea</p>
    //           ) : (
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th>Estudiante</th><th>Grado</th><th>Grupo</th><th>Respuesta</th><th>Archivo</th><th>Fecha entrega</th><th>Calificación</th><th>Acción</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {responses.map((r) => (
    //                   <tr key={r.id}>
    //                     <td>{r.estudiante_nombre}</td>
    //                     <td>{r.grado || "—"}</td>
    //                     <td>{r.grupo || "—"}</td>
    //                     <td style={{ maxWidth: "300px" }}>{r.respuesta?.trim() || <span style={{ opacity: 0.6 }}>Sin respuesta escrita</span>}</td>
    //                     <td>{r.archivo ? <a href={`${API_BASE}/uploads/${r.archivo}`} target="_blank" rel="noreferrer">📎</a> : <span style={{ opacity: 0.6 }}>—</span>}</td>
    //                     <td>{r.created_at ? new Date(r.created_at).toLocaleString() : "—"}</td>
    //                     <td>{r.calificacion ?? "—"}</td>
    //                     <td><button onClick={() => handleGrade(r.id)} style={{ cursor: "pointer" }}>⭐</button></td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           )}
    //         </div>
    //       )}

    //       {/* ===============================
    //          🚫 NO RESPONDIERON
    //       =============================== */}
    //       {vista === "no-respondidas" && (
    //         <div className="tabla-wrapper">
    //           <h3>Estudiantes que no respondieron</h3>
    //           <button onClick={() => setVista("historial")}>← Volver</button>
    //           {stats.length === 0 ? <p>Todos los estudiantes respondieron 🎉</p> : (
    //             <table>
    //               <thead><tr><th>Estudiante</th></tr></thead>
    //               <tbody>{stats.map((e) => <tr key={e.estudiante_id}><td>{e.nombre}</td></tr>)}</tbody>
    //             </table>
    //           )}
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // export default TareasProfesor;

import React, { useEffect, useState, useMemo } from "react";
import axios from "../api/axiosAuth";
import io from "socket.io-client";
import { useAuth } from "../context/AuthContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../style/tareas.css";

const API_TAREAS = "/tasks";
const FILE_BASE = process.env.REACT_APP_FILE_BASE || "http://localhost:5001";
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5001";

function TareasProfesor() {
  const { user, token, isProfesor } = useAuth();

  const [tareas, setTareas] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);

  const [selectedGrado, setSelectedGrado] = useState("");
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [selectedAsignacion, setSelectedAsignacion] = useState(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [archivo, setArchivo] = useState(null);

  const [responses, setResponses] = useState([]);
  const [stats, setStats] = useState([]);

  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [vista, setVista] = useState("historial");

  const [periodos, setPeriodos] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState("");

  const headers = useMemo(() => {
    if (!token || !user) return {};
    return {
      Authorization: `Bearer ${token}`,
      "X-Tenant-ID": user?.tenant_id,
      "X-Sede-ID": user?.sede_id || "",
    };
  }, [token, user]);

  useEffect(() => {
    if (!user || !token || !isProfesor()) return;

    cargarInicial();

    const socket = io(SOCKET_URL, { auth: { token } });

    socket.on(`teacher:${user.id}`, () => {
      if (periodoSeleccionado) fetchHistorial(periodoSeleccionado);
    });

    return () => socket.disconnect();
  }, [user, token]);

  const cargarInicial = async () => {
    await fetchPeriodos();
    await fetchPeriodoActivo();
    await fetchAsignaciones();
  };

  // const fetchPeriodos = async () => {
  //   try {
  //     const res = await axios.get(`${API_TAREAS}/periodos`, { headers });
  //     setPeriodos(res.data || []);
  //   } catch (err) {
  //     console.error("Error cargando periodos:", err);
  //   }
  // };

  // const fetchPeriodoActivo = async () => {
  //   try {
  //     const res = await axios.get(`${API_TAREAS}/periodos/activo`, { headers });
  //     if (res.data?.id) {
  //       setPeriodoSeleccionado(res.data.id);
  //       await fetchHistorial(res.data.id);
  //     }
  //   } catch (err) {
  //     console.error("Error periodo activo:", err);
  //   }
  // };

const fetchPeriodos = async () => {
  try {

    const res = await axios.get(
      `${API_TAREAS}/periodos`,
      { headers }
    );

    console.log("📚 Periodos:", res.data);

    if (Array.isArray(res.data)) {

      // Compatibilidad con versiones antiguas
      setPeriodos(res.data);

    } else {

      setPeriodos(res.data?.periodos || []);

    }

  } catch (err) {

    console.error("❌ Error cargando periodos:", err);
    setPeriodos([]);

  }
};

const fetchPeriodoActivo = async () => {
  try {

    const res = await axios.get(
      `${API_TAREAS}/periodos/activo`,
      { headers }
    );

    console.log("📅 Periodo activo:", res.data);

    const periodo =
      res.data?.periodo ||
      res.data;

    if (periodo?.id) {

      setPeriodoSeleccionado(periodo.id);

      await fetchHistorial(periodo.id);

    }

  } catch (err) {

    console.error("❌ Error periodo activo:", err);

  }
};
  const handlePeriodoChange = (id) => {
    setPeriodoSeleccionado(id);
    fetchHistorial(id);
  };

    // const fetchAsignaciones = async () => {
    //   try {
    //     const res = await axios.get(`${API_TAREAS}/profesor/asignaciones`, { headers });
    //     const data = res.data || [];
    //     setAsignaciones(data);
    //     setGrados([...new Set(data.map((a) => String(a.grado)))]);
    //   } catch (err) {
    //     console.error("Error cargando asignaciones:", err);
    //   }
    // };

    const fetchAsignaciones = async () => {
  try {

    const res = await axios.get(
      `${API_TAREAS}/profesor/asignaciones`,
      { headers }
    );

    console.log("📚 Respuesta asignaciones:", res.data);

    const asignaciones = Array.isArray(res.data?.asignaciones)
      ? res.data.asignaciones
      : [];

    setAsignaciones(asignaciones);

    setGrados(
      [
        ...new Set(
          asignaciones
            .map(a => String(a.grado))
            .filter(Boolean)
        )
      ]
    );

  } catch (err) {

    console.error(
      "❌ Error cargando asignaciones:",
      err
    );

    setAsignaciones([]);
    setGrados([]);

  }
};

  const handleGradoChange = (grado) => {
    setSelectedGrado(grado);
    setSelectedGrupo("");
    setSelectedAsignacion(null);

    const gruposFil = asignaciones
      .filter((a) => String(a.grado) === String(grado))
      .map((a) => String(a.grupo));

    setGrupos([...new Set(gruposFil)]);
  };

  const handleGrupoChange = (grupo) => {
    setSelectedGrupo(grupo);

    const asig = asignaciones.find(
      (a) =>
        String(a.grado) === String(selectedGrado) &&
        String(a.grupo) === String(grupo)
    );

    setSelectedAsignacion(asig?.asignacion_id || null);
  };

 const fetchHistorial = async (periodo_id) => {
  try {

    const res = await axios.get(
      `${API_TAREAS}/profesor/historial`,
      {
        params: { periodo_id },
        headers
      }
    );

    console.log("📚 Historial:", res.data);

    if (Array.isArray(res.data)) {

      setTareas(res.data);

    } else {

      setTareas(res.data?.tareas || []);

    }

  } catch (err) {

    console.error("❌ Error historial:", err);

    setTareas([]);

  }
};

  const handleCreateTask = async (e) => {
    e.preventDefault();

    if (!title || !dueDate || !selectedAsignacion) {
      return alert("Completa todos los campos");
    }

    const formData = new FormData();
    formData.append("asignacion_id", selectedAsignacion);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("due_date", dueDate);

    if (archivo) formData.append("archivo", archivo);

    try {
      await axios.post(API_TAREAS, formData, {
        headers: {
          ...headers,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("✅ Tarea creada correctamente");

      setTitle("");
      setDescription("");
      setDueDate("");
      setArchivo(null);
      setSelectedAsignacion(null);
      setSelectedGrupo("");
      setSelectedGrado("");

      fetchHistorial(periodoSeleccionado);
    } catch (err) {
      console.error("Error creando tarea:", err);
      alert(err.response?.data?.message || "Error creando tarea");
    }
  };

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("¿Seguro que deseas eliminar esta tarea?")) return;

      const res = await axios.delete(`${API_TAREAS}/${id}`, { headers });

      alert(res.data?.message || "Tarea eliminada correctamente");
      fetchHistorial(periodoSeleccionado);
    } catch (err) {
      console.error("Error eliminando:", err);
      alert(err.response?.data?.message || "Error eliminando tarea");
    }
  };

  const handleBloquear = async (id) => {
    try {
      await axios.put(`${API_TAREAS}/${id}/bloquear`, {}, { headers });
      fetchHistorial(periodoSeleccionado);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDesbloquear = async (id) => {
    try {
      await axios.put(`${API_TAREAS}/${id}/desbloquear`, {}, { headers });
      fetchHistorial(periodoSeleccionado);
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditar = async (t) => {
    try {
      const nuevoTitulo = prompt("Nuevo título", t.title);
      if (!nuevoTitulo) return;

      const nuevaDesc = prompt("Nueva descripción", t.description || "");
      const nuevaFecha = prompt("Nueva fecha", t.due_date?.slice(0, 16));

      await axios.put(`${API_TAREAS}/${t.id}`, {
        title: nuevoTitulo,
        description: nuevaDesc,
        due_date: nuevaFecha,
      }, { headers });

      fetchHistorial(periodoSeleccionado);
    } catch (err) {
      console.error(err);
      alert("Error editando tarea");
    }
  };

  const handleViewResponses = async (taskId) => {
    try {
      const res = await axios.get(`${API_TAREAS}/${taskId}/responses`, { headers });
      setResponses(res.data || []);
      setSelectedTaskId(taskId);
      setVista("respuestas");
    } catch (err) {
      console.error(err);
    }
  };

  const fetchNoRespondidas = async (taskId) => {
    try {
      const res = await axios.get(`${API_TAREAS}/${taskId}/no-respondidas`, { headers });
      setStats(res.data || []);
      setVista("norespondidas");
    } catch (err) {
      console.error(err);
    }
  };

  const handleGrade = async (id) => {
    try {
      const nota = prompt("Calificación");
      if (!nota) return;

      await axios.post(`${API_TAREAS}/responses/${id}/grade`, {
        calificacion: nota,
      }, { headers });

      handleViewResponses(selectedTaskId);
    } catch (err) {
      console.error(err);
      alert("Error calificando");
    }
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Historial de Tareas", 14, 15);

    autoTable(doc, {
      startY: 20,
      head: [["Título", "Grado", "Grupo", "Estado", "Respuestas"]],
      body: tareas.map((t) => [
        t.title,
        t.grado,
        t.grupo,
        t.estado,
        t.respuestas || 0,
      ]),
    });

    doc.save("tareas_profesor.pdf");
  };

  if (!user) return <p>Cargando...</p>;
  if (!isProfesor()) return <p>No autorizado</p>;

  return (
    <div className="tareas-wrapper">
      <h2>📝 Tareas Profesor</h2>

      {archivo && <p>📎 {archivo.name}</p>}

      <select value={periodoSeleccionado} onChange={(e) => handlePeriodoChange(e.target.value)}>
        <option value="">Periodo</option>
        {periodos.map((p) => (
          <option key={p.id} value={p.id}>{p.nombre}</option>
        ))}
      </select>

      <form onSubmit={handleCreateTask} encType="multipart/form-data">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Título" />
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción" />
        <input type="datetime-local" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />

        <select value={selectedGrado} onChange={(e) => handleGradoChange(e.target.value)}>
          <option value="">Grado</option>
          {grados.map((g) => <option key={g}>{g}</option>)}
        </select>

        <select value={selectedGrupo} onChange={(e) => handleGrupoChange(e.target.value)}>
          <option value="">Grupo</option>
          {grupos.map((g) => <option key={g}>{g}</option>)}
        </select>

        <input type="file" onChange={(e) => setArchivo(e.target.files[0])} />
        <button type="submit">Crear</button>
      </form>

      {vista === "historial" && (
        <>
          <button onClick={exportPDF}>📄 PDF</button>

          <table>
            <thead>
              <tr>
                <th>Título</th>
                <th>Grado</th>
                <th>Grupo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {tareas.map((t) => (
                <tr key={t.id}>
                  <td>{t.title}</td>
                  <td>{t.grado}</td>
                  <td>{t.grupo}</td>
                  <td>{t.estado}</td>
                  <td>
                    <button onClick={() => handleEditar(t)}>✏️</button>
                    <button onClick={() => handleDelete(t.id)}>🗑️</button>
                    <button onClick={() => handleBloquear(t.id)}>🔒</button>
                    <button onClick={() => handleDesbloquear(t.id)}>🔓</button>
                    <button onClick={() => handleViewResponses(t.id)}>👁</button>
                    {/* <button onClick={() => fetchNoRespondidas(t.id)}>📌</button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {vista === "respuestas" && (
        <div>
          <button onClick={() => setVista("historial")}>⬅ Volver</button>

          <table>
            <thead>
              <tr>
                <th>Estudiante</th>
                <th>Respuesta</th>
                <th>Archivo</th>
                <th>Nota</th>
              </tr>
            </thead>
            <tbody>
              {responses.map((r) => (
                <tr key={r.id}>
                  <td>{r.estudiante_nombre}</td>
                  <td>{r.respuesta}</td>
                  <td>
                    {r.archivo ? (
                      <a href={`${FILE_BASE}${r.archivo}`} target="_blank" rel="noreferrer">
                        Ver
                      </a>
                    ) : "-"}
                  </td>
                  <td>
                    <button onClick={() => handleGrade(r.id)}>
                      ⭐ {r.calificacion || "Calificar"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {vista === "norespondidas" && (
        <div>
          <button onClick={() => setVista("historial")}>⬅ Volver</button>

          <table>
            <thead>
              <tr>
                <th>Estudiante</th>
              </tr>
            </thead>
            <tbody>
              {stats.map((s, i) => (
                <tr key={i}>
                  <td>{s.estudiante}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default TareasProfesor;
